var borders_default = {
  "borderT": "_42Atg",
  "borderB": "Yco-E",
  "borderL": "qaQGZ",
  "borderR": "h97xT",
  "borderColorOverride": "Vd77K"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
